module.exports = __webpack_public_path__ + "img/bplus-home-ee.cc824a16.png";